import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import { openEditor } from '@common/reducers/RemindersUIReducer';
import { Fab, Tooltip } from '@mui/material';
import { BellPlus } from 'lucide-react';
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

type ReminderScope = 'current' | 'all';

interface NewReminderFabProps {
  scope?: ReminderScope;
  currentChatId?: string;
  currentChatDisplayName?: string;
}

const NewReminderFab: React.FC<NewReminderFabProps> = ({
  scope = 'all',
  currentChatId,
  currentChatDisplayName,
}) => {
  const { t } = useTranslation(namespace);
  const dispatch = useAppDispatch();
  const whatsappDirection = useAppSelector((state) => state.UserReducer.userWhatsappDirection);
  const isRTL = whatsappDirection === 'rtl';
  const isCurrentScopeWithoutChat = scope === 'current' && !currentChatId;

  const openAddReminderDialog = () => {
    dispatch(openEditor({
      reminder: undefined,
      context: scope === 'current' && currentChatId
        ? {
          chatId: currentChatId,
          chatDisplayName: currentChatDisplayName,
        }
        : {}
    }));
  };

  return (
    <Tooltip
      title={
        isCurrentScopeWithoutChat
          ? t('reminders.selectChatFirst')
          : scope === 'current'
            ? t('reminders.newReminderCurrentChat')
            : t('reminders.newReminder')
      }
      placement="left"
    >
      <Fab
        onClick={openAddReminderDialog}
        disabled={isCurrentScopeWithoutChat}
        data-testid="new-reminder-fab"
        sx={{
          position: 'fixed',
          bottom: '2rem',
          ...(isRTL ? { left: '2rem' } : { right: '2rem' }),
          background: 'var(--fab-bg)',
          color: 'var(--fab-text)',
          '&:hover': {
            background: 'var(--fab-hover-bg)',
          },
          zIndex: 1000,
        }}
      >
        <BellPlus size={20} style={{ color: 'var(--fab-text)' }} />
      </Fab>
    </Tooltip>
  );
};

export default NewReminderFab;
